import { Modal, Stack, TextArea, Title } from "@introist/react-foundation/v2";
import { useEffect, useState } from "react";
import { FormFooter } from "../modules/datasources/components/FormFooter";

export const ReportThreadModal = ({
  open,
  onClose,
  onSubmit
}: {
  open: boolean;
  onClose: () => unknown;
  onSubmit: (additionalInfo: string) => Promise<unknown>;
}) => {
  const [info, setInfo] = useState("");

  useEffect(() => {
    setInfo("");
  }, [open]);

  return (
    <Modal title="Send request to support" open={open} onClose={onClose} style={{ width: "600px" }}>
      <Stack vertical>
        <Title>
          Your request will be sent directly to support. The conversation with the assistant will be
          included but here you can provide any additional information you like.
        </Title>
        <TextArea
          autoFocus
          rows={5}
          placeholder="Additional information"
          value={info}
          onChange={setInfo}
        />
        <FormFooter onCancel={onClose} onSubmit={() => onSubmit(info)} submit="Send" />
      </Stack>
    </Modal>
  );
};
